export class Utils {
  static calculateAge = (
    dateBorn: Date,
    todayDate: Date
  ): { year: number; month: number; day: number } => {
    let year = todayDate.getFullYear() - dateBorn.getFullYear();
    let month = todayDate.getMonth() - dateBorn.getMonth();
    const day = todayDate.getDate() - dateBorn.getDate();

    if (month < 0) {
      year--;
      month += 12;
    }
    return { year, month, day };
  };

  static calculateAgeStr = (
    dateBorn: Date,
    todayDate: Date = new Date()
  ): string => {
    const date = Utils.calculateAge(dateBorn, todayDate);
    let age = '';

    if (date.year > 0) {
      const yearWord = date.year === 1 ? 'año' : 'años';
      age = `${date.year} ${yearWord}`;
    }

    if (date.year < 10) {
      if (date.month > 0) {
        const monthWord = date.month === 1 ? 'mes' : 'meses';
        age = `${age} ${date.month} ${monthWord}`;
      } else if (date.year === 0 && date.month === 0) {
        const dayWord = date.day === 1 ? 'día' : 'días';
        age = `${age} ${date.day} ${dayWord}`;
      }
    }
    return age;
  };

  static countDays = (startDate: Date, endDate: Date): number => {
    const oneDayTM = 1000 * 60 * 60 * 24;
    const quantity = endDate.getTime() - startDate.getTime();
    return Math.round(quantity / oneDayTM) + 1;
  };

  static transformAge = (age?: string | null) => {
    if (!age) {
      return '';
    }

    const ageParts = age.split('|').map((part) => +part);
    if (ageParts[0] > 12) {
      return `, ${ageParts[0]} años`;
    }

    const year =
      ageParts[0] === 0
        ? ''
        : ageParts[0] === 1
        ? ', 1 año'
        : `, ${ageParts[0]} años`;
    const month =
      ageParts[1] === 0
        ? ''
        : ageParts[1] === 1
        ? ', 1 mes'
        : `, ${ageParts[1]} meses`;
    const day =
      ageParts[2] === 0
        ? ''
        : ageParts[2] === 1
        ? ', 1 día'
        : `, ${ageParts[2]} dias`;

    return `${year}${month}${day}`;
  };

  static splitAge = (age?: string, splitter: string = '|'): string[] => {
    if (!age) {
      return [];
    }
    const split = age.split(splitter);

    if (+split[0] > 12) {
      return [`${split[0]} años`];
    }

    if (+split[0] === 1) {
      split[0] = `${split[0]} año`;
    } else if (+split[0] > 1) {
      split[0] = `${split[0]} años`;
    } else {
      split[1] = '';
    }

    if (+split[1] === 1) {
      split[1] = `${split[1]} mes`;
    } else if (+split[1] > 1) {
      split[1] = `${split[1]} meses`;
    } else {
      split[1] = '';
    }

    if (+split[2] === 1) {
      split[2] = `${split[2]} día`;
    } else if (+split[2] > 1) {
      split[2] = `${split[2]} días`;
    } else {
      split[2] = '';
    }
    return split;
  };

  static cloneFromTo = (fromObj: any, toObj: any) => {
    // tslint:disable-next-line
    for (const attr in fromObj) {
      toObj[attr] = fromObj[attr];
    }
  };

  static containsQuery = (parts: string[], value: string) =>
    parts.filter((part) => value.indexOf(part) > -1).length === parts.length;

  static normalizeText = (textToReplace: string): string =>
    textToReplace
      .toLowerCase()
      .replace(/[áäà]/gi, 'a')
      .replace(/[éëè]/gi, 'e')
      .replace(/[íïì]/gi, 'i')
      .replace(/[óöò]/gi, 'o')
      .replace(/[úüù]/gi, 'u')
      .replace(/[ñ]/gi, 'n');
}
